import { PerspectiveType } from "@xmiles/holopix-ai";
import { FreePerspectiveCameraParams, FreePerspectivePresetOption, FreePerspectiveSizeOption } from "./types";

export const FREE_PERSPECTIVE_DEFAULT_CAMERA: FreePerspectiveCameraParams = {
  horizontalAngle: 0,
  verticalAngle: 0,
  distance: 5.0,
};

export const FREE_PERSPECTIVE_PRESET_OPTIONS: FreePerspectivePresetOption[] = [
  {
    id: PerspectiveType.Front,
    label: "正视图",
    cameraParams: {
      horizontalAngle: 0,
      verticalAngle: 0,
      distance: 5.0,
    },
    legacyAliases: ["front", "正视图", "正面", "front_view"],
  },
  {
    id: PerspectiveType.SideAngle,
    label: "斜侧图",
    cameraParams: {
      horizontalAngle: 45,
      verticalAngle: 0,
      distance: 5.0,
    },
    legacyAliases: ["side_angle", "斜侧图", "斜侧"],
  },
  {
    id: PerspectiveType.Side,
    label: "侧视图",
    cameraParams: {
      horizontalAngle: 90,
      verticalAngle: 0,
      distance: 5.0,
    },
    legacyAliases: ["side", "侧视图", "侧面"],
  },
  {
    id: PerspectiveType.Top,
    label: "俯视",
    cameraParams: {
      horizontalAngle: 0,
      verticalAngle: 60,
      distance: 5.0,
    },
    legacyAliases: ["top", "俯视", "三视图", "three_view"],
  },
  {
    id: PerspectiveType.Bottom,
    label: "仰视",
    cameraParams: {
      horizontalAngle: 0,
      verticalAngle: -30,
      distance: 5.0,
    },
    legacyAliases: ["bottom", "仰视", "底视"],
  },
  {
    id: PerspectiveType.Back,
    label: "背视",
    cameraParams: {
      horizontalAngle: 180,
      verticalAngle: 0,
      distance: 5.0,
    },
    legacyAliases: ["back", "背视", "后视", "six_view"],
  },
];

export const FREE_PERSPECTIVE_SIZE_OPTIONS: FreePerspectiveSizeOption[] = [
  {
    value: "1024",
    label: "极速(1024)",
    estimateSeconds: 15,
    consumePower: 5,
    badge: "none",
  },
  {
    value: "1536",
    label: "高清(1536)",
    estimateSeconds: 20,
    consumePower: 10,
    // 业务规则：1536 高清尺寸为 VIP 专属，非会员不可用
    badge: "vip",
  },
];

export const FREE_PERSPECTIVE_LEGACY_VIEW_COUNT_ALIASES: Record<string, PerspectiveType> = {
  "1": PerspectiveType.Front,
  "front": PerspectiveType.Front,
  "front_view": PerspectiveType.Front,
  "正视图": PerspectiveType.Front,
  "正面": PerspectiveType.Front,
  "2": PerspectiveType.SideAngle,
  "side_angle": PerspectiveType.SideAngle,
  "斜侧图": PerspectiveType.SideAngle,
  "斜侧": PerspectiveType.SideAngle,
  "3": PerspectiveType.Side,
  "side": PerspectiveType.Side,
  "侧视图": PerspectiveType.Side,
  "侧面": PerspectiveType.Side,
  "4": PerspectiveType.Top,
  "top": PerspectiveType.Top,
  "俯视": PerspectiveType.Top,
  "three_view": PerspectiveType.Top,
  "三视图": PerspectiveType.Top,
  "5": PerspectiveType.Bottom,
  "bottom": PerspectiveType.Bottom,
  "仰视": PerspectiveType.Bottom,
  "底视": PerspectiveType.Bottom,
  "6": PerspectiveType.Back,
  "back": PerspectiveType.Back,
  "背视": PerspectiveType.Back,
  "后视": PerspectiveType.Back,
  "six_view": PerspectiveType.Back,
  "六视图": PerspectiveType.Back,
};

export const FREE_PERSPECTIVE_LEGACY_SOURCE_ALIASES: Record<string, string> = {
  preset_click: "preset_click",
  camera_drag: "camera_drag",
  slider: "slider",
  default: "default",
  re_edit: "re_edit",
};
